import { connect } from "react-redux";
import React, { Fragment, Component } from "react";
import { loadMatches, setFavorite, getFavorites } from "../actions/userActions";
import { setAnnoucementListener } from "../actions/landlordActions";
import { requestState } from "../actions/utils";
import LoadingContent from "../components/Helpers/LoadingContent";

class MatchContainer extends Component {

    // constructor( props ) {
    //     super( props );
    //     props.clearMatches();
    // }

    componentDidMount() {
        if ( !this.props.customMatches ) {
            this.props.loadMatches();
            this.props.setAsListener( this.props.loadMatches );
        }
        // this.props.getFavorites();
    }

    componentWillUnmount() {
        if ( !this.props.customMatches ) {
            this.props.setAsListener( undefined );
        }
    }

    render() {
        const { component, matchLoadState, ...props } = this.props;
        const Page = component;
        if ( matchLoadState === requestState.inProgress )
            return <LoadingContent/>;
        return (
            <Fragment>
                <Page loadState={matchLoadState} {...props}/>
            </Fragment>
        );
    }

}

function mapStateToProps( state, ownProps ) {
    return {
        matchLoadState: state.user.matchState,
        matches: ownProps.matches || state.user.matches,
        customMatches : Boolean( ownProps.matches ),
        component: ownProps.component,
        favoriteMatches: state.user.favoriteMatches // TODO: Remove as it is not implemented and will probably not be
    }
}

function mapDispatchToProps( dispatch, ownProps ) {
    return {
        // clearMatches: () => dispatch( setUserMatches( [] ) ),
        setAsListener: ( f ) => dispatch( setAnnoucementListener( f ) ),
        loadMatches: () => dispatch( loadMatches() ),
        getFavorites: () => dispatch(getFavorites()),
        setFavorite: ( id, favorite ) => dispatch( setFavorite( id, favorite ) )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( MatchContainer );